import React, { createContext, useContext, useState, useCallback } from 'react';
import { api } from '../services/api';

const ConfigContext = createContext(null);

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState({
        googleMapsKey:  '',
        graphHopperUrl: process.env.REACT_APP_GRAPHHOPPER_API_URL || '',
        appVersion:     '1.0.0',
    });

    // Called once after login succeeds. Fetches runtime config from the DB
    // (GoogleMaps:ApiKey, GraphHopper:BaseUrl, App:Version) with a 5-minute
    // server-side cache, so key rotation takes effect within 5 minutes.
    const loadConfig = useCallback(async () => {
        try {
            const { data } = await api.get('/api/Settings/routing');
            setConfig({
                googleMapsKey:  data.googleMapsKey  || '',
                graphHopperUrl: data.graphHopperUrl || process.env.REACT_APP_GRAPHHOPPER_API_URL || '',
                appVersion:     data.appVersion     || '1.0.0',
            });
        } catch {
            // Silently fall back to env-var defaults so the app remains usable
            // even if the AppSettings table hasn't been migrated yet.
        }
    }, []);

    return (
        <ConfigContext.Provider value={{ config, loadConfig }}>
            {children}
        </ConfigContext.Provider>
    );
};
